import { useMemo } from "react";

import { useTireResults } from "../../useTireResults";
import { useSpeedIndex } from "./useSpeedIndex";

export const useSpeedIndexOptions = (): Option[] => {
  const { data: info } = useTireResults({
    keepPreviousData: true,
  });
  const [state] = useSpeedIndex();
  const options = useMemo((): Option[] => {
    if (!info) return [];
    const acc = {} as Record<string, null>;
    for (const { partDetails } of info.allParts) {
      const { tireSpeedIndex } = partDetails.primaryPart;
      acc[tireSpeedIndex] = null;
    }
    const entries = Object.entries(acc);
    const result = entries
      .map(([tireSpeedIndex]) => {
        const count = info.allParts.reduce(
          (acc, { partDetails }) =>
            partDetails.primaryPart.tireSpeedIndex === tireSpeedIndex
              ? acc + 1
              : acc,
          0
        );
        const checked = state.includes(tireSpeedIndex);
        return { checked, count, tireSpeedIndex };
      })
      .sort((a, b) => a.tireSpeedIndex.localeCompare(b.tireSpeedIndex));
    return result;
  }, [info?.allParts, state]);
  return options;
};

type Option = {
  checked: boolean;
  count: number;
  tireSpeedIndex: string;
};
